export const updateObject: React.FC = (oldObject, updatedProperties) => {
    return {
        ...oldObject,
        ...updatedProperties
    };
};
// Correctly define updateObject function

// export const updateObject = <T extends object>(oldObject: T, updatedProperties: Partial<T>): T => {
//     return {
//         ...oldObject,
//         ...updatedProperties
//     };
// };
